import React, { useEffect, useState } from "react";
import CourseHeader from "../../components/customCoursework/CourseHeader/CourseHeader";
import { NavigationProp, useNavigation, useRoute } from "@react-navigation/native";
import { RootStackParamList } from "../../navigation/AppNavigator.web";
import { useActiveCourse } from "../../contexts/ActiveCourseContext";
import { View } from "react-native";

const studentRoutes = [
  "Custom Course Student",
  "Custom Assignment Student",
  "Custom Resource Student",
  "Custom Course AITutor",
  "Custom Course Assessment",
];

const formatDate = (isoDateString) => {
  if (!isoDateString) return "";

  const date = new Date(isoDateString);
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  return `${month}-${day}-${year}`;
};

const CourseHeaderContainer = () => {
  const [title, setTitle] = useState("");
  const [label, setLabel] = useState("");
  const navigation = useNavigation<NavigationProp<RootStackParamList>>();
  const {
    params: { courseId: courseIdQueryParam1, course_id: courseIdQueryParam },
    name: routeName,
  } = useRoute();

  const {
    courseData,
    courseId,
    handleOpenGenerateDialog,
    handleTogglePublishDialog,
    isSubmitting,
    assignmentData,
    loadingAssignment,
    setActiveResource,
    userSubmissionsData,
    loadingUserSubmissions,
    axioResourceData,
  } = useActiveCourse();

  const handleExitPress = () => {
    setActiveResource(null);
    if (studentRoutes.includes(routeName)) {
      handleNavigateToStudentView();
    } else {
      navigation.navigate("Home");
    }
  };

  const handleOpenCourseSettings = () => {
    navigation.navigate("Course Settings", { courseId, tab: "courseInfo" });
  };

  const handleNavigateToStudentView = () => {
    navigation.navigate("Custom Course Student", {
      course_id: courseId || courseIdQueryParam || courseIdQueryParam1,
    });
  };

  const course = courseData?.getCourseById?.data?.[0];
  const isDraft = course?.isDraft;
  const moduleCount = course?.modules?.length ?? 0;
  const showRightSection = routeName === "Custom Coursework Modules";

  useEffect(() => {
    if (routeName === "Custom Assignment Student") {
      setTitle(assignmentData?.getAssignment?.data?.[0]?.name);
    } else if (routeName === "Custom Resource Student") {
      setTitle(axioResourceData?.getAxioResource?.data?.[0]?.name);
    } else {
      setTitle(course?.name ?? "Course");
    }
  }, [assignmentData, course, axioResourceData]);

  useEffect(() => {
    if (routeName === "Custom Assignment Student") {
      if (userSubmissionsData?.getUserSubmissions?.data?.[0]) {
        setLabel("Graded");
      } else {
        setLabel(`Due ${formatDate(assignmentData?.getAssignment?.data?.[0]?.due_date)}`);
      }
    } else if (routeName === "Custom Resource Student") {
      setLabel("");
    } else {
      setLabel(course?.isDraft ? "Draft" : "Published");
    }
  }, [assignmentData, course, userSubmissionsData, routeName]);

  if (loadingUserSubmissions || loadingAssignment) {
    return <View style={{ height: 62 }}></View>;
  }

  return (
    <CourseHeader
      title={title}
      label={label}
      isDraft={isDraft}
      moduleCount={moduleCount}
      onExit={handleExitPress}
      onOpenSettings={handleOpenCourseSettings}
      onNavigateToStudentView={handleNavigateToStudentView}
      onOpenGenerateDialog={handleOpenGenerateDialog}
      onTriggerPublishToggle={handleTogglePublishDialog}
      isSubmitting={isSubmitting}
      showRightSection={showRightSection}
    />
  );
};

export default CourseHeaderContainer;
